import React, { useState, useEffect, useCallback } from 'react';
import { fetchBusRoutesByCity } from '../api/busApi';
import Select from 'react-select';


const RouteSelect = ({ city, onRouteChange, className, onApiError }) => {
  const [busRoutes, setBusRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRouteName, setSelectedRouteName] = useState(null);
  const [routeFullName, setRouteFullName] = useState(null);


  // Convert busRoutes to options for react-select
  const options = busRoutes
    .map(route => ({
      value: route.RouteName.Zh_tw,
      label: `[${route.RouteName.Zh_tw}] ${route.DepartureStopNameZh} ↔︎ ${route.DestinationStopNameZh}`,
      route: route // Store the whole route object
    }));

  const clearRoute = useCallback(()=>{
    setSelectedRouteName(null);
    setRouteFullName(null);
  },[]);

  useEffect(() => {
    onRouteChange({route: selectedRouteName, routeName:routeFullName});
  }, [selectedRouteName, routeFullName, onRouteChange]);

  useEffect(() => {
    if (!city) return;
    clearRoute();
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchBusRoutesByCity(city);
        // const response = await fetch(`mockResponse/cityRoutes.json`);
        // response.data = await response.json(); 
        setBusRoutes(response.data.sort(function (a, b) {
          return a.RouteName.Zh_tw.localeCompare(b.RouteName.Zh_tw)
        }));
      } catch (error) {
        // api error handler for demo use
        const response = await fetch(`mockResponse/cityRoutes.json`);
        response.data = await response.json(); 
        onApiError();
        setBusRoutes(response.data.sort(function (a, b) {
          return a.RouteName.Zh_tw.localeCompare(b.RouteName.Zh_tw)
        }));
        // setError(error);
      }
      setLoading(false);
    };

    fetchData();
  }, [city]);

  const selectRoute = (event) => {
    const selectedRouteName = event.value;
    setSelectedRouteName(selectedRouteName);
    const selectedRoute = busRoutes.find(route => route.RouteName.Zh_tw === selectedRouteName);
    const routeFullName = selectedRoute
    ? `${selectedRoute.DepartureStopNameZh} ↔︎ ${selectedRoute.DestinationStopNameZh}`
    : '未知的路線名稱';
    setRouteFullName(routeFullName);
  };

  const selectedOption = options.find(option => option.value === selectedRouteName) || null;

  return (
    <div className={className}>
      <Select
        options={options}
        value={selectedOption}
        onChange={selectRoute}
        isDisabled={!city}
        isLoading={loading}
        classNames={{
          control: (state) =>
            state.isFocused ? 'focus' : '',
        }}
        noOptionsMessage={() => (error ? `對不起，目前出現錯誤: ${error.message}` : "沒有符合項目")}
        placeholder="請輸入或選擇公車路線"
      />
    </div>
  );
};

export default RouteSelect;